import { Observable } from 'rxjs';
import { DataSourceResponse, WhoDirected } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class WhoDirectedService extends ApiService {
  endPoint = '/api/whoDirecteds';

  create(model: WhoDirected) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: WhoDirected) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<WhoDirected> {
    return this.http.get<WhoDirected>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<WhoDirected>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
}
